export enum ScoreType {
  Skill = 0 /* Returns all Skills, with each Skill's Score */,
  SkillType = 1 /* Returns all SkillTypes, with each SkillType's Score */,
  SkillSubType = 2 /* Returns all SkillSubTypes, with each SkillSubType's Score */,
  CareerPath = 3 /* Returns the Score for a Career Path, careerPathSlug must be provided */,
  Role = 4 /* Returns the Score for a Role, roleSlug must be provided */,
  RoleSkill = 5 /* Returns all Skills in a Role, with each Skill's Score, roleSlug must be provided */
}
